import { render, staticRenderFns } from "./ProjetBlocFore.vue?vue&type=template&id=5c346460&scoped=true&lang=true&"
import script from "./ProjetBlocFore.vue?vue&type=script&lang=js&"
export * from "./ProjetBlocFore.vue?vue&type=script&lang=js&"
import style0 from "./ProjetBlocFore.vue?vue&type=style&index=0&id=5c346460&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c346460",
  null
  
)

export default component.exports